import React from 'react';
import { motion } from 'framer-motion';

const FilterSidebar = ({ filters, onFilterChange, onClearFilters, categories, className = '' }) => {
  const priceRanges = [
    { label: 'Under ₹1,000', value: '0-1000' },
    { label: '₹1,000 - ₹2,500', value: '1000-2500' },
    { label: '₹2,500 - ₹5,000', value: '2500-5000' },
    { label: '₹5,000 - ₹10,000', value: '5000-10000' },
    { label: 'Above ₹10,000', value: '10000' }
  ];

  const sizes = ['XS', 'S', 'M', 'L', 'XL', 'XXL'];

  return (
    <motion.div
      className={`bg-white rounded-lg shadow-sm p-6 ${className}`}
      initial={{ opacity: 0, x: -20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-serif font-medium text-deep-brown">Filters</h3>
        <button
          onClick={onClearFilters}
          className="text-sm text-warm-gray hover:text-deep-brown transition-colors duration-200"
        >
          Clear All
        </button>
      </div>

      {/* Category Filter */}
      <div className="mb-8">
        <h4 className="font-medium text-deep-brown mb-4">Category</h4>
        <div className="space-y-3">
          <label className="flex items-center">
            <input
              type="radio"
              name="category"
              value=""
              checked={filters.category === ''}
              onChange={(e) => onFilterChange('category', e.target.value)}
              className="w-4 h-4 text-deep-brown border-warm-gray/30 focus:ring-deep-brown focus:ring-offset-0"
            />
            <span className="ml-3 text-sm text-deep-brown">All Categories</span>
          </label>
          {categories.map((category) => (
            <label key={category} className="flex items-center">
              <input
                type="radio"
                name="category"
                value={category}
                checked={filters.category === category}
                onChange={(e) => onFilterChange('category', e.target.value)}
                className="w-4 h-4 text-deep-brown border-warm-gray/30 focus:ring-deep-brown focus:ring-offset-0"
              />
              <span className="ml-3 text-sm text-deep-brown">{category}</span>
            </label>
          ))}
        </div>
      </div>

      {/* Price Range Filter */}
      <div className="mb-8">
        <h4 className="font-medium text-deep-brown mb-4">Price Range</h4>
        <div className="space-y-3">
          <label className="flex items-center">
            <input
              type="radio"
              name="priceRange"
              value=""
              checked={filters.priceRange === ''}
              onChange={(e) => onFilterChange('priceRange', e.target.value)}
              className="w-4 h-4 text-deep-brown border-warm-gray/30 focus:ring-deep-brown focus:ring-offset-0"
            />
            <span className="ml-3 text-sm text-deep-brown">All Prices</span>
          </label>
          {priceRanges.map((range) => (
            <label key={range.value} className="flex items-center">
              <input
                type="radio"
                name="priceRange"
                value={range.value}
                checked={filters.priceRange === range.value}
                onChange={(e) => onFilterChange('priceRange', e.target.value)}
                className="w-4 h-4 text-deep-brown border-warm-gray/30 focus:ring-deep-brown focus:ring-offset-0"
              />
              <span className="ml-3 text-sm text-deep-brown">{range.label}</span>
            </label>
          ))}
        </div>
      </div>

      {/* Size Filter */}
      <div className="mb-8">
        <h4 className="font-medium text-deep-brown mb-4">Size</h4>
        <div className="grid grid-cols-3 gap-2">
          {sizes.map((size) => (
            <button
              key={size}
              onClick={() => onFilterChange('size', filters.size === size ? '' : size)}
              className={`py-2 px-3 text-sm border border-warm-gray/30 transition-all duration-200 ${
                filters.size === size
                  ? 'bg-deep-brown text-white border-deep-brown'
                  : 'bg-white text-deep-brown hover:border-deep-brown'
              }`}
            >
              {size}
            </button>
          ))}
        </div>
      </div>

      {/* Active Filters */}
      {(filters.category || filters.priceRange || filters.size) && (
        <div className="pt-6 border-t border-warm-gray/20">
          <h4 className="font-medium text-deep-brown mb-3">Active Filters</h4>
          <div className="flex flex-wrap gap-2">
            {filters.category && (
              <span className="inline-flex items-center px-3 py-1 rounded-full text-xs bg-deep-brown text-white">
                {filters.category}
                <button
                  onClick={() => onFilterChange('category', '')}
                  className="ml-2 hover:text-warm-gray"
                >
                  ×
                </button>
              </span>
            )}
            {filters.priceRange && (
              <span className="inline-flex items-center px-3 py-1 rounded-full text-xs bg-deep-brown text-white">
                {priceRanges.find(r => r.value === filters.priceRange)?.label}
                <button
                  onClick={() => onFilterChange('priceRange', '')}
                  className="ml-2 hover:text-warm-gray"
                >
                  ×
                </button>
              </span>
            )}
            {filters.size && (
              <span className="inline-flex items-center px-3 py-1 rounded-full text-xs bg-deep-brown text-white">
                Size {filters.size}
                <button
                  onClick={() => onFilterChange('size', '')}
                  className="ml-2 hover:text-warm-gray"
                >
                  ×
                </button>
              </span>
            )}
          </div>
        </div>
      )}
    </motion.div>
  );
};

export default FilterSidebar;